import {Component, Input, OnInit} from "@angular/core";
import {Invoice, MicroPaymentSession} from "../../dto/invoice";

@Component({
  selector: 'app-customer-micropayment-sessions-view',
  templateUrl: './customer-micropayment-sessions-view.component.html',
  styleUrls: ['./customer-micropayment-sessions-view.component.css']
})
export class CustomerMicropaymentSessionsViewComponent implements OnInit {
  @Input() sessions: MicroPaymentSession[];
  @Input() isLoading = false;

  constructor() { }

  ngOnInit() {}


}
